import { SourceBlock } from "../../pipeline/tiles.pipeline.sourceblock";
import { WebClient } from "../../../io/webClient";
import { TextUtils } from "../../../utils/text";
export class TilesetCodec {
    async decodeAsync(r) {
        return r instanceof Response ? (await r.json()) : null;
    }
}
export class Tile3dStreamingEngineOptions {
}
Tile3dStreamingEngineOptions.Default = {
    tilesetExtension: "json",
};
export class TileNode {
    constructor(tile, tilesetUri, parent = null) {
        this.tile = tile;
        this.parent = parent;
        this.children = [];
        this.tilesetUri = tilesetUri;
    }
    addChild(child) {
        this.children.push(child);
    }
}
export class TilesetCache {
    constructor() {
        this.cache = new Map();
    }
    get(tilesetUri) {
        return this.cache.get(tilesetUri) || null;
    }
    set(tilesetUri, tileset) {
        this.cache.set(tilesetUri, tileset);
    }
    has(tilesetUri) {
        return this.cache.has(tilesetUri);
    }
}
export class Tile3dStreamingEngine extends SourceBlock {
    constructor(uri, options) {
        super();
        this._actives = [];
        this._uri = uri;
        this._root = null;
        this._cache = options?.cache ?? new TilesetCache();
        this._client = options?.webClient ?? new WebClient(uri, new TilesetCodec());
        this._options = { ...Tile3dStreamingEngineOptions.Default, ...options };
    }
    setContext(state, display) {
        if (!state || !display) {
            this._doClearContext();
            return;
        }
        this._doValidateContext(state, display);
    }
    _doClearContext() { }
    _doValidateContext(state, display) {
        if (this._root === null) {
            this._doFetchTilesetAsync(this._uri).then((tileset) => {
                if (tileset) {
                    this._root = new TileNode(tileset.root, this._uri, null);
                    this._doValidateContext(state, display);
                }
            });
            return;
        }
        this._browseTilesetHierarchy(this._root.tile, state, display, this._uri);
    }
    async _browseTilesetHierarchy(tile, state, display, baseUrl) {
        if (!tile)
            return;
        if (!this._isTileVisible(tile, state, display)) {
            return;
        }
        const uri = tile.content?.uri;
        const ext = uri ? TextUtils.GetUriExtension(uri)?.toLowerCase() : null;
        if (uri && ext && ext === (this._options.tilesetExtension?.toLowerCase() ?? "json")) {
            const contentUrl = new URL(uri, baseUrl).toString();
            const tileset = await this._doFetchTilesetAsync(contentUrl);
            if (tileset && tileset.root) {
                await this._browseTilesetHierarchy(tileset.root, state, display, contentUrl);
            }
        }
        if (tile.children) {
            for (const child of tile.children) {
                await this._browseTilesetHierarchy(child, state, display, baseUrl);
            }
        }
    }
    _isTileVisible(tile, state, display) {
        return true;
    }
    async _doFetchTilesetAsync(uri) {
        const result = await this._client.fetchAsync(this._uri);
        return result.content;
    }
}
//# sourceMappingURL=tile3d.streaming.engine.js.map